/* Keep blocked forms inert even when the theme updates variant controls. */
document.addEventListener('submit',function(event){
  if(event.target instanceof HTMLFormElement && event.target.querySelector('[data-hrg-unavailable-form]')){
    event.preventDefault();
    event.stopImmediatePropagation();
  }
},true);

/* Recently viewed cards are built from product JSON rather than Liquid. */
if(window.theme && typeof theme.buildProductGridItem === 'function'){
  const originalBuild = theme.buildProductGridItem;
  theme.buildProductGridItem = function(items,gridWidth,rowOf,imageSizes){
    const template = document.createElement('template');
    template.innerHTML = originalBuild.call(this,items,gridWidth,rowOf,imageSizes);
    Array.from(template.content.children).forEach(function(card,index){
      const tags = items[index] && items[index].tags;
      const tagList = Array.isArray(tags) ? tags : typeof tags === 'string' ? tags.split(',').map(function(tag){return tag.trim();}) : [];
      if(!tagList.includes('Temporarily Unavailable')) return;
      card.classList.add('hrg-unavailable-card');
      const label = document.createElement('span');
      label.className = 'btn btn--full hrg-unavailable-button hrg-unavailable-card__label';
      label.textContent = 'Product Temporarily Unavailable';
      const image = card.querySelector('.grid-product__image-mask');
      if(image) image.insertAdjacentElement('afterend',label);
    });
    return template.innerHTML;
  };
}
